import React from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
const StyledErrorLabel = styled.label `
    display: block;
    margin-top: 5px;
    font-weight: 600;
    font-size: 15px;
    color: ${color.error.base};
`;
const ErrorLabel = ({ children }) => (React.createElement(StyledErrorLabel, null, children));
export default ErrorLabel;
